import { BrowserRouter, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { AppRoutes } from './router'
import { AuthProvider } from './context/AuthContext'

function ScrollToTop() {
  const { hash, pathname } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const targetId = decodeURIComponent(hash.slice(1))
    const timeoutId = window.setTimeout(() => {
      document.getElementById(targetId)?.scrollIntoView({ behavior: 'auto', block: 'start' })
    }, 0)

    return () => window.clearTimeout(timeoutId)
  }, [hash, pathname])

  return null
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
